<section id="heroSectionAboutPage" class="md:px-3 lg:px-6 mb-8 lg:mb-16 flex justify-center bg-gradient-to-b from-[#7B8693] to-[#DDE2E7] pt-28 pb-28 max-md:px-2">
  <div class="flex flex-col  text-white w-full max-w-[1330px]">
    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8">
      <div class="flex flex-col">
        <div class="font-tektur text-[#1F2125] text-8xl font-bold max-md:text-7xl max-md:mb-2.5" i18n>About Us</div>
        <div class="font-tektur max-w-md text-xl text-mainColor" i18n>
          It’s hard to help everyone but we do our best. Join a campaign you like and help us help these warriors.
        </div>
        <div class="font-tektur max-w-md text-mainColor text-base mt-12" i18n>
          People from totally different industries like IT or logistics, education or media PR have united with a common mission and a common wish.
        </div>
        <div class="font-tektur max-w-md text-mainColor text-base mt-6" i18n>
          Since day 1 of the full-scale invasion, our warriors require mobility. Together with over 250 volunteers from all
          over the globe, we are committed to serving our heroes and providing them 4x4 and other cars for as long as it takes.
        </div>
      </div>
      <div>
        <img src="assets/images/about/hero.png" alt="hero" class="max-w-full h-auto">
      </div>
    </div>

  </div>
</section>
